import { createReducer, on } from '@ngrx/store';
import {
  shareReport,
  shareReportSuccess,
  shareReportFailure,
  editPrompt,
  editPromptSuccess,
  editPromptFailure,
  refineIcpScore,
  refineIcpScoreSuccess,
  refineIcpScoreFailure,
  changeCompany,
  changeCompanySuccess,
  changeCompanyFailure,
  clearChangeCompanyState,
  updateCompany,
  clearAssistantPrompts,
  updateReportStatusInStore,
} from './report.actions';

export interface ReportState {
  search: any;
  loading: boolean;
  error: any;
  company: any;
}


export const initialState: ReportState = {
  search: null,
  loading: false,
  error: null,
  company: null,
};

export const reportReducer = createReducer(
  initialState,

  on(shareReport, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(shareReportSuccess, (state) => {
    // console.log('Register success', user);
    return { ...state, loading: false, error: null };
  }),
  on(shareReportFailure, (state, { error }) => {
    return { ...state, error, loading: false, token: null };
  }),

  on(editPrompt, state => ({
    ...state,
    promptUpdateLoading: true,
    promptUpdateSuccess: null,
    promptUpdateError: null
  })),
  on(editPromptSuccess, (state, { response }) => ({
    ...state,
    promptUpdateLoading: false,
    promptUpdateSuccess: response
  })),
  on(editPromptFailure, (state, { error }) => ({
    ...state,
    promptUpdateLoading: false,
    promptUpdateError: error
  })),

  on(refineIcpScore, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(refineIcpScoreSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    result: result,
  })),

  on(refineIcpScoreFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(changeCompany, (state) => ({
    ...state,
    result: null,
    error: null,
    loading: true,
  })),

  on(changeCompanySuccess, (state, { response }) => {
    // console.log('Reducer handling changeCompanySuccess with response:', response);
    return {
      ...state,
      loading: false,
      result: response, // Update the state with the response
    };
  }),

  on(changeCompanyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(clearChangeCompanyState, (state) => ({
    ...state,
    result: null,
    error: null,
  })),

  on(updateCompany, (state, { company }) => ({
    ...state,
    company, // Update the company property in the state
  })),

  on(clearAssistantPrompts, (state) => {
    if (!state.company) {
      return state; // If there's no company, return the state unchanged
    }

    return {
      ...state,
      company: {
        ...state.company,
        assistant_prompts: [], // Clear the assistant prompts
      },
    };
  }),

  on(updateReportStatusInStore, (state, { statusId }) => ({
    ...state,
    search: state.search ? {
      ...state.search,
      report: {
        ...state.search.report,
        search_status_id: statusId
      }
    } : null
  })),

);
